<button class="{{'btn' + (buttonClass ? (' ' + buttonClass) : '')}}"
        [type]="type"
        [disabled]="loading || disabled"
        [ngClass]="ngClass"
        (click)="onClick($event)">

  @if (loading) {
    <fa-icon icon="spinner" animation="spin" [fixedWidth]="true" />
  } @else if (faIcon) {
    <fa-icon [icon]="faIcon" [fixedWidth]="true" />
  } @else if (appIcon) {
    <app-icon [size]="appIconSize" [name]="appIcon" />
  }

  @if (label) {
    <span>{{label | messageTranslate}}</span>
  } @else if (labelString) {
    <span>{{labelString}}</span>
  }

  <ng-content></ng-content>

</button>
